<template>
  <div class="container-detail">
    <div class="detail-header-buttons">
      <div class="header-buttons-left">
        <v-btn
          @click="back"
          style="width: auto !important"
          class="button-accept"
        >
          <v-icon>mdi-chevron-left</v-icon>
          Вернуться к списку кандидатов
        </v-btn>
      </div>

      <div class="header-buttons-right">
        <v-btn
          @click="dialogDelete = true"
          style="width: auto !important"
          class="button-accept-outlined"
          outlined
          color="var(--app-red-1)"
        >
          Удалить
        </v-btn>
        <v-btn
          @click="goToEdit"
          style="width: auto !important"
          class="button-action-blue"
        >
          Редактировать
        </v-btn>
      </div>
    </div>

    <div class="detail-main">
      <div class="detail-main-first-container" v-if="candidate">
        <div class="first-container-box">
          <div class="container-box-title">ФИО</div>
          <div class="container-box-text">
            {{ getFullName(candidate) }}
          </div>
        </div>
        <div class="first-container-box">
          <div class="container-box-title">Биография</div>
          <div class="container-box-text">
            {{ candidate.bio }}
          </div>
        </div>
      </div>
      <div class="detail-main-second-container">
        <div class="second-container-box">
          <div class="container-box-title">Фотография кандидата</div>
          <div class="container-box-text">
            Нажмите на изображение, чтобы увидеть его в полном размере
          </div>
        </div>

        <div>
          <v-simple-table v-if="candidate">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Формат</th>
                  <th class="text-left">Место отображенния</th>
                  <th class="text-left">Для смартфонов</th>
                  <th class="text-left">Для планшетов</th>
                </tr>
              </thead>
              <tbody>
                <tr style="height: 60px">
                  <td class="text-left">Фото</td>
                  <td class="text-left">
                    Отображается в списке и разделе «Выборы КСА»
                  </td>
                  <td class="text-left">
                    <img
                      @click="openDialogImg(candidate.imageMobile)"
                      v-if="candidate.imageMobile"
                      class="table-img"
                      :src="candidate.imageMobile"
                    />
                  </td>
                  <td class="text-left">
                    <img
                      @click="openDialogImg(candidate.imageTablet)"
                      v-if="candidate.imageTablet"
                      class="table-img"
                      :src="candidate.imageTablet"
                    />
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-dialog
            width="600px"
            height="auto"
            persistent
            no-click-animation
            :content-class="'dialog-delete-custom'"
            v-model="dialogDelete"
          >
            <v-card class="delete-wrapper">
              <v-card-title
                style="
                  display: flex;
                  justify-content: space-between;
                  padding: 30px 24px 30px;
                "
                class="dialog-title-custom"
              >
                <div
                  class="title-custom"
                  style="
                    color: var(--app-dark-blue-1);
                    font-weight: 500;
                    font-size: 24px;
                    line-height: 20px;
                  "
                >
                  Удаление кандидата
                </div>
                <v-icon @click="dialogDelete = false">mdi-close</v-icon>
              </v-card-title>
              <v-card-text
                style="
                  font-weight: 400;
                  font-size: 18px;
                  line-height: 24px;
                  letter-spacing: 0px;
                "
                >Вы уверены, что хотите удалить кандидата из общего списка
                выборов КСА?</v-card-text
              >
              <v-card-actions class="dialog-buttons">
                <v-btn
                  @click="deleteCandidate"
                  style="width: 120px; margin-left: auto"
                  class="button-cancel"
                  color="var(--app-red-1)"
                >
                  Удалить
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <DialogImage v-model="dialogImg" :src="previewImage" />
          <v-divider></v-divider>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from "../../../store";

export default {
  data: () => ({
    candidate: null,
    dialogImg: false,
    previewImage: null,
    hideNews: false,
    imageWidth: 0,
    dialogDelete: false,
  }),
  methods: {
    openDialogImg(src) {
      this.previewImage = src;
      this.dialogImg = true;
    },
    back() {
      this.$router.go(-1);
    },
    goToEdit() {
      this.$router.push({
        name: "EditCandidate",
        params: { id: this.$route.params.id },
      });
    },
    getFullName(item) {
      return `${item.user.lastName} ${item.user.firstName} ${item.user.middleName}`;
    },
    getCandidate() {
      this.$axios
        .get(
          this.$store.getters.apiAdminPanelV5 +
            "/ksa-election-candidates/" +
            this.$route.params.id,
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then((res) => {
          this.candidate = res.data;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    deleteCandidate() {
      this.$axios
        .delete(
          this.$store.getters.apiAdminPanelV5 +
            "/ksa-election-candidates/" +
            this.$route.params.id,
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then(() => {
          store.commit("errorSet", {
            key: true,
            text: "Кандидат успешно удален",
            type: "success",
          });
          this.$router.push({
            name: "Candidates",
          });
        });
    },
  },
  created() {
    this.getCandidate();
  },
};
</script>
<style lang="scss" scoped>
.container-detail {
  box-sizing: border-box;
  padding: 40px !important;

  .detail-header-buttons {
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;

    .header-buttons-right {
      display: flex;
      align-items: center;
      gap: 18px;
    }
  }

  .detail-main {
    display: flex;
    justify-content: space-between;

    .detail-main-first-container {
      width: 48%;

      .first-container-box {
        margin-bottom: 40px;

        .container-box-title {
          font-size: 24px;
          font-weight: 600;
        }

        .container-box-text {
          font-size: 18px;
          font-weight: 400;
        }

        .container-box-text-list {
          .container-box-text-list-item {
            display: flex;
            margin-bottom: 5px;

            .list-item-subtitle {
              font-size: 16px;
              font-weight: 600;
              color: #929292;
              width: 200px;
            }

            .list-item-text {
              font-size: 18px;
              font-weight: 400;
            }
          }
        }
      }
    }

    .detail-main-second-container {
      width: 48%;

      .table-img {
        cursor: pointer;
        height: 38px;
        object-fit: contain;
      }

      .second-container-box {
        width: 100%;
        margin-bottom: 40px;

        .container-box-title {
          font-size: 24px;
          font-weight: 600;
        }

        .container-box-text {
          font-size: 18px;
          font-weight: 400;
        }
      }
    }
  }
  .dialog-delete-custom {
    .delete-wrapper {
      .dialog-title-custom {
        .title-custom {
          font-weight: 500;
          font-size: 24px;
          line-height: 20px;
          color: var(--app-dark-blue-3);
        }
      }
    }
  }
}
</style>
